import { CoordinatingGroupGetCollectionByTrialCode, CoordinatingGroupCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<CoordinatingGroupCollectionResponse, CoordinatingGroupCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<CoordinatingGroupCollectionResponse, CoordinatingGroupCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useCoordinatingGroups = (trialCode: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new CoordinatingGroupGetCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useCoordinatingGroups;